import { render, staticRenderFns } from "./FourOFour.vue?vue&type=template&id=0ba66f8a&scoped=true&"
import script from "./FourOFour.vue?vue&type=script&lang=js&"
export * from "./FourOFour.vue?vue&type=script&lang=js&"
import style0 from "./FourOFour.vue?vue&type=style&index=0&id=0ba66f8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba66f8a",
  null
  
)

export default component.exports